'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var PropTypes = require('prop-types');
var index = require('../IconSvg/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var InputFile = function InputFile(_ref) {
  var onChange = _ref.onChange,
      id = _ref.id,
      label = _ref.label,
      placeholder = _ref.placeholder,
      allowedTypes = _ref.allowedTypes,
      className = _ref.className,
      error = _ref.error,
      multiple = _ref.multiple;
  var fileInput = React.useRef(null);

  var _useState = React.useState([]),
      _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2),
      files = _useState2[0],
      attachFiles = _useState2[1];

  var updateFileList = function updateFileList(attachedFiles) {
    var dT = new DataTransfer();
    attachedFiles.forEach(function (f) {
      return dT.items.add(f);
    });
    fileInput.current.files = dT.files;
  };

  var update = function update(newFiles) {
    attachFiles(newFiles);
    onChange.apply(void 0, _rollupPluginBabelHelpers.toConsumableArray(newFiles));
    updateFileList(newFiles);
  };

  var handleFileInput = function handleFileInput(e) {
    update(multiple ? [].concat(_rollupPluginBabelHelpers.toConsumableArray(files), _rollupPluginBabelHelpers.toConsumableArray(e.target.files)) : _rollupPluginBabelHelpers.toConsumableArray(e.target.files));
  };

  var handleFileRemove = function handleFileRemove(name) {
    var attachedFiles = files.filter(function (f) {
      return f.name !== name;
    });
    update(attachedFiles);
  };

  var classNames = typeof className === 'string' && className !== '' ? "".concat(className, " ds-atom-input-file") : 'ds-atom-input-file';
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNames
  }, /*#__PURE__*/React__default['default'].createElement("ul", {
    className: "ds-atom-input-file-list"
  }, files.length > 0 ? files.map(function (f) {
    return /*#__PURE__*/React__default['default'].createElement("li", {
      key: f.name || f,
      className: "ds-atom-input-file-name"
    }, /*#__PURE__*/React__default['default'].createElement("button", {
      type: "button",
      onClick: function onClick() {
        return handleFileRemove(f.name);
      }
    }, /*#__PURE__*/React__default['default'].createElement(index, {
      icon: "cross-light"
    })), /*#__PURE__*/React__default['default'].createElement("span", null, f.name));
  }) : /*#__PURE__*/React__default['default'].createElement("li", {
    className: "ds-atom-input-file-caption"
  }, placeholder)), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ds-atom-input-file-control"
  }, /*#__PURE__*/React__default['default'].createElement("input", {
    type: "file",
    onChange: handleFileInput,
    ref: fileInput,
    name: id,
    id: id,
    accept: allowedTypes,
    multiple: multiple
  }), /*#__PURE__*/React__default['default'].createElement("label", {
    htmlFor: id
  }, label), error && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ds-atom-input-file-error"
  }, error)));
};
InputFile.propTypes = {
  onChange: PropTypes__default['default'].func,
  label: PropTypes__default['default'].string,
  id: PropTypes__default['default'].string.isRequired,
  placeholder: PropTypes__default['default'].string,
  allowedTypes: PropTypes__default['default'].string,
  className: PropTypes__default['default'].string,
  error: PropTypes__default['default'].string,
  multiple: PropTypes__default['default'].bool
};
InputFile.defaultProps = {
  onChange: function onChange() {},
  allowedTypes: '',
  label: 'Attach file',
  placeholder: 'No attached files',
  className: '',
  error: '',
  multiple: false
};

exports.InputFile = InputFile;
exports.default = InputFile;
